// extracted by mini-css-extract-plugin
export default {"root":"StyledQr_root__zBSpy","canvas":"StyledQr_canvas__43+LL"};